// Actions se utiliza para obtener,establecer o guardar datos
import Vue from "vue";
import axios from "axios";
import { i18n } from "./../../main";

export async function signIn({ commit }, login) {
  commit("setLoading", true, { root: true });
  let resp = false;
  await axios
    .post("login/authenticate", login, {})
    .then(response => {
      if (response.status === 200) {
        window.localStorage.setItem("_token", response.data.resp.TOKEN);
        commit("setUser", response.data.resp);
        commit("setUsuarios", response.data.response);
        commit("setLogin", login);
        resp = true;
      }
    })
    .catch(error => {
      //commit("authError", error.message);
      const message = error.response && error.response.data
        ? error.response.data.Message
        : "No se ha podido conectar con el servidor";
      console.log("ERROR " + message);
      Vue.prototype.$toast(message, {
        color: "red"
      });
    });
  commit("setLoading", false, { root: true });
  return resp;
}

export async function changePassword({ commit }, newPassword) {
  console.log("Token: " + window.localStorage.getItem("_token"));
  let res = await fetch(
    Vue.prototype.$apiRoute + "login/changePassword?password=" + newPassword,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    }
  );
  let resJson = await res.json();
  if (!res.ok) {
    Vue.prototype.$toast(resJson.Message, { color: "red" });
  } else {
    Vue.prototype.$toast(i18n.t('mensajes.contraseñaActualizada'), {
      color: "green"
    });
  }
  return res.ok;
}

export async function logOut({ commit }, login) {
  commit("logout");
  commit('services/clearServices', null, { root: true })
  commit('services/setNecesitaRecargar', true, { root: true })
  commit('services/setFiltro', null, { root: true })
  /*commit("setLoading", true, { root: true });
    await axios
      .post(Vue.prototype.$apiRoute + "login/logout", login, {})
      .then(response => {
        if (response.status === 200) {
          window.localStorage.removeItem("_token");
          commit("logout", response.data);
        }
      });*/
}
